import { jsx as _jsx } from "react/jsx-runtime";
//import React from "react";
import ErrorBoundary from "./ErrorBoundary";
function Main({ children }) {
    return (_jsx("main", { className: "h-full dark:bg-black", children: _jsx("div", { className: "2xl:container lg:mx-auto grid h-full relative", children: _jsx(ErrorBoundary, { children: children }) }) }));
}
export default Main;
